import React from "react"

const Leadoo = ({ name, className }) => {
  return (
    <div className={className}>
      {process.env.NODE_ENV === "production" ? (
        <ld-slot name={name}></ld-slot>
      ) : (
        <span>Leadoo element: {name} (not enabled in dev environment)</span>
      )}
    </div>
  )
}

export default Leadoo
